import React, { memo, useMemo } from 'react';
import Card from '@Utils/Card';
import { Spin } from 'antd';
import { QuestionChart } from './chart';
import './overview.scss';

function SurveyOverview(props) {
  if (props.loading) {
    return (
      <div className="survey-loading">
        <Spin spinning />
      </div>
    );
  }

  const { displayed, submitted, responseRate } = useMemo(() => {
    const { completed = 0 } = props.data ?? {};

    const delivered = props.aggregations?.delivered;

    const displayed = delivered ? delivered : delivered;
    const submitted = completed ? completed : completed;
    const responseRate = delivered
      ? ((completed / delivered) * 100).toFixed(2)
      : 0;

    return { displayed, submitted, responseRate };
  }, [props]);

  return (
    <div className="survey-overview-container">
      <div className="survey-summary-section">
        <Card styles={{ width: '100%' }}>
          <div className="survey-summary-card">
            <div
              className="survey-indicator"
              style={{
                background: '#EB5F95',
              }}
            />
            <span>Displayed</span>
          </div>
          <div className="survey-summary-value">{`${displayed}`}</div>
        </Card>
        {false && (
          <Card>
            <div className="survey-summary-card">
              <div
                className="survey-indicator"
                style={{
                  background: '#89C0F7',
                }}
              />
              <span>Attempted</span>
            </div>
            <div className="survey-summary-value">0</div>
          </Card>
        )}
        <Card>
          <div className="survey-summary-card">
            <div
              className="survey-indicator"
              style={{
                background: '#D84A43',
              }}
            />
            <span>Submitted</span>
          </div>
          <div className="survey-summary-value">{`${submitted}`}</div>
        </Card>
        <Card>
          <div className="survey-summary-card">
            <div
              className="survey-indicator"
              style={{
                background: '#70F4FB',
              }}
            />
            <span>Response-Rate</span>
          </div>
          <div className="survey-summary-value">{`${responseRate}%`}</div>
        </Card>
      </div>
      {props.data.questions?.map((question) => (
        <Card key={question.id}>
          <div className="survey-card-title">
            <span>{question.body}</span>
          </div>
          <div style={{ display: 'flex', padding: 24 }}>
            <QuestionChart question={question} />
          </div>
        </Card>
      ))}
    </div>
  );
}

const Memoized = memo(SurveyOverview);

export { Memoized as SurveyOverview };
